/* CM-55: finish picker label + one-line description (placeholder wording; Alyson reworks).
   Reads the checked finish radio, so it survives the variant-selects AJAX re-render.
   Rev 3: "Size guide" / "Compare finishes" switch the listing's own gallery image (no modal);
   finish swatches are sized so their row spans the size-button row. */
(function () {
  if (window.__rimPdp) return;
  window.__rimPdp = true;
  var DESC = [
    ['natural oak', 'Light, warm wood grain; at home with almost any palette'],
    ['espresso', 'Deep brown wood grain; warm and grounded'],
    ['black', 'Crisp and graphic; sets off bold colour cleanly'],
    ['gold', 'Soft gold over visible wood grain; warm, never shiny'],
    ['silver', 'Soft silver over visible wood grain; cool, never shiny'],
    ['wrap', 'Frameless; the canvas wraps the edges']
  ];
  function describe(value) {
    var v = value.toLowerCase();
    for (var i = 0; i < DESC.length; i++) if (v.indexOf(DESC[i][0]) !== -1) return DESC[i][1];
    return '';
  }
  function set(el, text) { if (el.textContent !== text) el.textContent = text; }
  function sync() {
    document.querySelectorAll('[data-rim-finish-label]').forEach(function (label) {
      var fieldset = label.closest('fieldset');
      if (!fieldset) return;
      var desc = fieldset.querySelector('[data-rim-finish-desc]');
      var checked = fieldset.querySelector('input:checked');
      if (!checked) {
        set(label, 'Select finish');
        if (desc) { set(desc, ''); desc.hidden = true; }
        return;
      }
      var parts = checked.value.split(/\s+[–—-]\s+/);
      set(label, parts.length > 1 ? parts[0] + ': ' + parts.slice(1).join(' – ') : parts[0]);
      var text = describe(checked.value);
      if (desc) { set(desc, text); desc.hidden = !text; }
    });
    sizeSwatches();
  }
  /* Swatch width = (size-button row width - gaps) / swatch count, so both rows end at the same edge. */
  function sizeSwatches() {
    document.querySelectorAll('fieldset.product-form__input--swatch').forEach(function (fs) {
      var labels = fs.querySelectorAll('.swatch-input__label');
      if (!labels.length) return;
      var scope = fs.closest('variant-selects') || document;
      var pills = scope.querySelectorAll('.product-form__input--pill label');
      var left = fs.getBoundingClientRect().left, right = 0;
      pills.forEach(function (p) { var r = p.getBoundingClientRect(); if (r.width) right = Math.max(right, r.right); });
      var row = right ? right - left : fs.getBoundingClientRect().width;
      if (row <= 0) return;
      var gap = 8, n = labels.length;
      var w = Math.floor(((row - gap * (n - 1)) / n) * 10) / 10;
      var v = w + 'px';
      if (fs.style.getPropertyValue('--rim-sw') !== v) fs.style.setProperty('--rim-sw', v);
    });
  }
  var queued = false;
  function queue() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; sync(); }); }
  document.addEventListener('change', function () { setTimeout(sync, 0); });
  /* Size guide / Compare finishes: select that image in the product's own media gallery, as its thumbnail does. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-rim-media]') : null;
    if (!b) return;
    e.preventDefault();
    var gallery = document.querySelector('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
    var item = gallery.querySelector('[id^="GalleryViewer"] [data-media-id$="-' + b.getAttribute('data-rim-media') + '"]');
    if (item) gallery.setActiveMedia(item.getAttribute('data-media-id'), false);
  });
  window.addEventListener('resize', queue);
  new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  window.addEventListener('load', queue);
  /* CM-63: the choice rule. Shopify fills any option the customer has not chosen, so the page cannot tell
     from its own state what was clicked. Track the customer's own clicks on the option pickers and layer two
     things on top of whatever Shopify renders: until every option has been clicked the price reads
     "From $X" (X = the lowest available variant matching the clicks so far) and Add to Cart stays disabled.
     A ?variant= link counts as every option chosen. Prices are read from /products/<handle>.js, never typed. */
  var picks = [];
  var pickedAll = /[?&]variant=/.test(location.search);
  var productData = null;
  function pickerFieldsets() {
    var root = document.querySelector('product-info variant-selects, product-info variant-radios');
    return root ? root.querySelectorAll('fieldset') : [];
  }
  function allPicked() {
    var n = pickerFieldsets().length;
    if (pickedAll || !n) return true;
    if (productData && productData.options.length !== n) return true;
    for (var i = 0; i < n; i++) if (picks[i] == null) return false;
    return true;
  }
  function money(cents) {
    var cur = window.Shopify && Shopify.currency && Shopify.currency.active;
    if (!cur) return null;
    var whole = cents % 100 === 0;
    return new Intl.NumberFormat('en-US', {
      style: 'currency', currency: cur,
      minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2
    }).format(cents / 100);
  }
  /* Price text for what has been clicked: the lowest available matching variant, "From" until all are clicked. */
  function wantedPrice() {
    if (pickedAll || !productData) return null;
    var low = null;
    productData.variants.forEach(function (v) {
      for (var i = 0; i < v.options.length; i++) if (picks[i] != null && v.options[i] !== picks[i]) return;
      if (v.available && (low === null || v.price < low)) low = v.price;
    });
    var text = low === null ? null : money(low);
    return text === null ? null : (allPicked() ? text : 'From ' + text);
  }
  function setText(el, text) { if (el.textContent.trim() !== text) el.textContent = text; }
  function gate(btn, on) {
    if (on) {
      if (!btn.hasAttribute('data-rim-gated')) btn.setAttribute('data-rim-gated', '');
      if (!btn.hasAttribute('disabled')) btn.setAttribute('disabled', '');
      if (btn.getAttribute('aria-disabled') !== 'true') btn.setAttribute('aria-disabled', 'true');
      var span = btn.querySelector('span');
      if (span) setText(span, 'Select Options');
    } else if (btn.hasAttribute('data-rim-gated')) {
      btn.removeAttribute('data-rim-gated');
      btn.removeAttribute('aria-disabled');
    }
  }
  /* The accelerated checkout (Shop Pay) rewrites its own disabled attribute, so it is gated with inert instead. */
  function gatePay(el, on) {
    if (on) {
      if (!el.inert) el.inert = true;
      if (el.style.opacity !== '0.5') el.style.opacity = '0.5';
      if (!el.hasAttribute('data-rim-gated')) el.setAttribute('data-rim-gated', '');
    } else if (el.hasAttribute('data-rim-gated')) {
      el.inert = false;
      el.style.opacity = '';
      el.removeAttribute('data-rim-gated');
    }
  }
  function applyChoice() {
    var info = document.querySelector('product-info');
    if (!info) return;
    var done = allPicked();
    /* Shopify writes the variant it filled in to the URL; a reload or a back/forward that does not restore the
       page would then read it as a deliberate ?variant= link. Keep the URL clean until every option is clicked. */
    if (!done && /[?&]variant=/.test(location.search)) {
      var query = location.search.replace(/([?&])variant=[^&]*&?/, '$1').replace(/[?&]$/, '');
      history.replaceState(history.state, '', location.pathname + query + location.hash);
    }
    var btn = info.querySelector('.product-form__submit');
    if (btn) gate(btn, !done);
    var pay = info.querySelector('shopify-accelerated-checkout');
    if (pay) gatePay(pay, !done);
    var text = wantedPrice();
    if (text === null) return;
    info.querySelectorAll('[id^="price-"] .price').forEach(function (price) {
      if (!done) price.classList.remove('price--on-sale');
      price.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale').forEach(function (el) {
        if (el.closest('s') || (done && !/^From/.test(el.textContent.trim()))) return;
        setText(el, text);
      });
    });
  }
  function onPick(e) {
    var t = e.target;
    if (!e.isTrusted || !t || t.type !== 'radio' || !t.closest || !t.closest('product-info')) return;
    var i = Array.prototype.indexOf.call(pickerFieldsets(), t.closest('fieldset'));
    if (i < 0) return;
    picks[i] = t.value;
    applyChoice();
  }
  document.addEventListener('click', onPick, true);
  document.addEventListener('change', onPick, true);
  document.addEventListener('submit', function (e) {
    if (!allPicked() && e.target.matches && e.target.matches('form[data-type="add-to-cart-form"]')) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);
  new MutationObserver(applyChoice).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
  function loadProduct() {
    var info = document.querySelector('product-info');
    if (!info || !info.dataset.url || productData) return;
    fetch(info.dataset.url.split('?')[0] + '.js').then(function (r) { return r.json(); }).then(function (p) {
      productData = p;
      applyChoice();
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadProduct); else loadProduct();
}());